import React from "react";

export type ProductEmptyStateProps = {
  title?: string;
  description?: string;
};

const styles = {
  wrap: {
    width: "100%",
    minHeight: 180,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    boxSizing: "border-box",
    border: "1px dashed rgba(17, 17, 17, 0.16)",
    borderRadius: 18,
    background:
      "linear-gradient(180deg, rgba(250, 250, 250, 0.96) 0%, rgba(244, 244, 245, 0.96) 100%)",
    color: "#111111",
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  inner: {
    width: "100%",
    maxWidth: 520,
    display: "grid",
    justifyItems: "center",
    gap: 10,
    textAlign: "center",
  },
  iconWrap: {
    width: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 999,
    border: "1px solid rgba(17, 17, 17, 0.10)",
    background: "#ffffff",
    boxShadow: "0 8px 22px rgba(0, 0, 0, 0.06)",
  },
  icon: {
    width: 22,
    height: 22,
    display: "block",
    color: "rgba(17, 17, 17, 0.52)",
  },
  title: {
    margin: 0,
    padding: 0,
    fontSize: 18,
    lineHeight: 1.25,
    fontWeight: 700,
    letterSpacing: "-0.02em",
    color: "#111111",
  },
  description: {
    margin: 0,
    padding: 0,
    fontSize: 14,
    lineHeight: 1.6,
    fontWeight: 400,
    color: "rgba(17, 17, 17, 0.64)",
  },
} satisfies Record<string, React.CSSProperties>;

export default function ProductEmptyState({
  title = "No products to display",
  description = "There are no matching products for this view yet.",
}: ProductEmptyStateProps) {
  return (
    <div style={styles.wrap} role="status" aria-live="polite">
      <div style={styles.inner}>
        <div style={styles.iconWrap} aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={styles.icon}
          >
            <path
              d="M4.75 7.75H19.25V18.25C19.25 18.8023 18.8023 19.25 18.25 19.25H5.75C5.19772 19.25 4.75 18.8023 4.75 18.25V7.75Z"
              stroke="currentColor"
              strokeWidth="1.5"
            />
            <path
              d="M8.25 7.75V6.75C8.25 4.67893 9.92893 3 12 3C14.0711 3 15.75 4.67893 15.75 6.75V7.75"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M9 12.25H15"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h3 style={styles.title}>{title}</h3>
        <p style={styles.description}>{description}</p>
      </div>
    </div>
  );
}
